import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Tooltip } from '@mui/material';

const MicrosoftIcon = () => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    sx={{ width: 20, height: 20, mr: 1 }}
    aria-hidden
  >
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </Box>
);

const MicrosoftLoginButtonV2 = ({ disabled, loading, onClick, tooltipTitle }) => {
  const button = (
    <Button
      fullWidth
      size="large"
      variant="outlined"
      color="inherit"
      disabled={disabled || loading}
      onClick={onClick}
      sx={{
        borderColor: 'divider',
        color: 'text.primary',
        '&:hover': {
          borderColor: 'text.secondary',
          bgcolor: 'action.hover',
        },
      }}
    >
      <MicrosoftIcon />
      {loading ? 'Conectando…' : 'Entrar com Microsoft'}
    </Button>
  );

  if (disabled && tooltipTitle) {
    return (
      <Tooltip title={tooltipTitle} arrow>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

MicrosoftLoginButtonV2.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  tooltipTitle: PropTypes.string,
};

MicrosoftLoginButtonV2.defaultProps = {
  disabled: false,
  loading: false,
  onClick: undefined,
  tooltipTitle: '',
};

export default MicrosoftLoginButtonV2;
